import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import React from "react";
var Option = function (_a) {
    var color = _a.color, width = _a.width, first = _a.first, last = _a.last;
    return (_jsx(Box, { sx: {
            bgcolor: color,
            width: width,
            height: 8,
            borderTopLeftRadius: first ? "2px" : 0,
            borderBottomLeftRadius: first ? "2px" : 0,
            borderTopRightRadius: last ? "2px" : 0,
            borderBottomRightRadius: last ? "2px" : 0,
        } }));
};
export default React.memo(Option);
